import type { PolicyRule } from '@salonomy/types';
import { renderPolicyText } from './policyText.js';

/**
 * Live plain-English preview of exactly what a client is shown before they commit. Rendered locally
 * from the SAME structured rule the form is editing (no round-trip), so it updates instantly as the
 * salon types — and it matches, sentence-for-sentence, the text the API freezes into a policy_version
 * on save (apps/api/src/modules/policy/service.ts → renderPolicyText). Honesty brand: UK English, no
 * asterisks, no hedging.
 */
export function PolicyTextPreview({ rule }: { rule: PolicyRule }) {
  const { depositText, cancellationText, noShowText } = renderPolicyText(rule);
  return (
    <div
      style={{
        background: 'var(--slm-porcelain)',
        border: '1px solid var(--slm-border)',
        borderRadius: 10,
        padding: '12px 14px',
      }}
    >
      <div
        className="mono"
        style={{ fontSize: 11, letterSpacing: '0.04em', textTransform: 'uppercase' }}
      >
        What your client sees
      </div>
      <p style={{ margin: '8px 0 0', fontSize: 13.5, lineHeight: 1.6 }}>{depositText}</p>
      <p style={{ margin: '6px 0 0', fontSize: 13.5, lineHeight: 1.6 }}>{cancellationText}</p>
      <p style={{ margin: '6px 0 0', fontSize: 13.5, lineHeight: 1.6 }}>{noShowText}</p>
    </div>
  );
}
